// Added by Sejune Oh on 2020-03-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
class LegacyEvtHandler  {
   addEvtListener(evtId: string, callback: Function) {
     // @ts-ignore
     if(window.clapp && window.clapp.event) window.clapp.event.onEvent.apply(window.clapp.event, [evtId, callback])
  }

  removeEvtListener(evtId: string, callback: Function) {
    // @ts-ignore
    if(window.clapp && window.clapp.event) window.clapp.event.offEvent.apply(window.clapp.event, [evtId, callback])
  }

  dispatchEvt(evtId: string, eventData: any) {
    // @ts-ignore
    if(window.clapp && window.clapp.event) window.clapp.event.fire.apply(window.clapp.event, [evtId, eventData])
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  addGlobalEvtListener(routerId: string, routerFunctor: Function) {
    // @ts-ignore
    if(window.clapp && window.clapp.eventDataRouterMan) window.clapp.eventDataRouterMan.addRouter.apply(window.clapp.eventDataRouterMan, [routerId, routerFunctor])
  }

  removeGlobalEvtListener(routerId: string, routerFunctor: Function) {
    // @ts-ignore
    if(window.clapp && window.clapp.eventDataRouterMan) window.clapp.eventDataRouterMan.removeRouter.apply(window.clapp.eventDataRouterMan, [routerId, routerFunctor])
  }
}

const legacyEvtHandler: LegacyEvtHandler = new LegacyEvtHandler()
export default legacyEvtHandler
